<template>
  <div class="page-section">
    <section-title :title="title" :collapsible="collapsible" :collapsed="isCollapsed" @toggle="toggleCollapse">
      <slot name="title"></slot>
    </section-title>
    <div class="section-content" v-show="!isCollapsed">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import SectionTitle from "./SectionTitle.vue";

export default {
  name: "page-section",
  components: { SectionTitle },
  props: {
    title: String,
    collapsible: {
      type: Boolean,
      default: false,
    },
    collapsed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isCollapsed: this.collapsed,
    };
  },
  mounted() {},
  methods: {
    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed;
    },
  },
};
</script>

<style scoped>
.page-section {
}
</style>
